import { render, staticRenderFns } from "./ContactCreateMixin.vue?vue&type=template&id=444a2206&"
import script from "./ContactCreateMixin.vue?vue&type=script&lang=js&"
export * from "./ContactCreateMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports